import markdownit from "markdown-it"
import { MarkdownParser } from 'prosemirror-markdown';
import { Schema } from "prosemirror-model";

let nodes = {
  blockquote: {block: "blockquote"},
  paragraph: {block: "paragraph"},
  list_item: {block: "list_item"},
  //bullet_list: {block: "bullet_list", getAttrs: (_, tokens, i) => ({tight: listIsTight(tokens, i)})},
  //ordered_list: {block: "ordered_list", getAttrs: (tok, tokens, i) => ({
  //  order: +tok.attrGet("start") || 1,
  //  tight: listIsTight(tokens, i)
  //})},
  heading: {block: "heading", getAttrs: tok => ({level: +tok.tag.slice(1)})},
  code_block: {block: "code_block", noCloseToken: true},
  fence: {block: "code_block", getAttrs: tok => ({params: tok.info || ""}), noCloseToken: true},
  hr: {node: "horizontal_rule"},
  image: {node: "image", getAttrs: tok => ({
    src: tok.attrGet("src"),
    title: tok.attrGet("title") || null,
    alt: tok.children[0] && tok.children[0].content || null
  })},
  hardbreak: {node: "hard_break"},

  em: {mark: "em"},
  strong: {mark: "strong"},
  link: {mark: "link", getAttrs: tok => ({
    href: tok.attrGet("href"),
    title: tok.attrGet("title") || null
  })},
  code_inline: {mark: "code", noCloseToken: true}
}

export function getMarkdownParser(schema: Schema) {
  let nodeNames = Object.keys(schema.nodes);
  let markNames = Object.keys(schema.marks);
  let wantedNodes: any  = {};
  for (let i=0; i<nodeNames.length; i++) {
    let nodeName = nodeNames[i];
    if (nodes[nodeName]) {
      wantedNodes[nodeName] = nodes[nodeName];
    }
  }
  for (let i=0; i<markNames.length; i++) {
    let nodeName = markNames[i];
    if (nodes[nodeName]) {
      wantedNodes[nodeName] = nodes[nodeName];
    }
  }
  if (!wantedNodes.paragraph) {
    wantedNodes.paragraph = {
      ignore: true
    };
  }

  let markdownitInstance = markdownit('commonmark', {
    html: false,
    breaks: true,
    linkify: true
  });

  return new MarkdownParser(schema, markdownitInstance, wantedNodes);
}
